import React from 'react';
import { withTranslation } from 'react-i18next';
import styled from 'styled-components';

import { isMobileApp } from '../../utils/getHost';
import { MID_GREY, DARK_GREY } from '../../utils/colours';

import translationKeys from '../../translations/keys';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 60vh;
    padding: 2rem;
    text-align: center;
`;

const Title = styled.h2`
    color: ${DARK_GREY};
    font-size: 1.5rem;
    margin-bottom: 1rem;
    font-weight: 600;
`;

const Message = styled.p`
    color: ${MID_GREY};
    font-size: 1rem;
    margin-bottom: 2rem;
    line-height: 1.5;
    max-width: 300px;
`;

const RefreshButton = styled.button`
    background-color: #007bff;
    color: white;
    border: none;
    padding: 0.75rem 1.5rem;
    border-radius: 0.5rem;
    font-size: 1rem;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover:not(:disabled) {
        background-color: #0056b3;
    }

    &:active:not(:disabled) {
        background-color: #004494;
    }

`;

const MobileNoConnectivity = ({t}) => {

    const handleRefresh = () => {
        window.location.reload();
    };

    // Only show on mobile when there's no connectivity
    if (!isMobileApp) {
        return null;
    };

    return (
        <Container>
            <RefreshButton onClick={handleRefresh}>
                {t(translationKeys.network.REFRESH)}
            </RefreshButton>
            <Title>{t(translationKeys.network.NO_INTERNET_CONNECTION)}</Title>
            <Message>
                {t(translationKeys.network.MOBILE_NO_CONNECTIVITY_MESSAGE)}
            </Message>

        </Container>
    );
};

export default withTranslation()(MobileNoConnectivity);